import axios from 'axios'
import Vue from 'vue'
import {Raven} from 'vue-raven'
import {ERROR} from '../ui/UI'
import {AppPermissions} from '../../../types/permissions/permissions'

export const WORKFLOW_PERMISSIONS_FETCH = 'WORKFLOW_PERMISSIONS_FETCH'
export const WORKFLOW_PERMISSIONS_SET = 'WORKFLOW_PERMISSIONS_SET'
export const WORKFLOW_PERMISSIONS_UPDATE = 'WORKFLOW_PERMISSIONS_UPDATE'

const state = {
    /**
     *  {[workflowUuid]: {
     *       [userUuid]: WorkflowPermissions
     *  }}
     **/
    permissions: {}
}

const getters = {
    permissions: state => state.permissions || {},
    getWorkflowPermissions: (state, getters) => workflowUuid => getters.permissions[workflowUuid] || {},

    canViewWorkflow: (state, getters, rootState, rootGetters) => workflow => {
        if (!workflow || !workflow.uuid) {
            return false
        }
        return getters.canEditWorkflow(workflow) ||
            getters.getWorkflowPermissions(workflow.uuid)[rootGetters.userUUID] // any role
    },
    canEditWorkflow: (state, getters, rootState, rootGetters) => workflow => {
        if (!workflow || !workflow.uuid) {
            return false
        }
        return rootGetters.isAdminOrStaff ||
            rootGetters.userUUID === workflow.owner_uuid ||
            [
                AppPermissions.ADMIN,
                AppPermissions.FULL
            ].includes(getters.getWorkflowPermissions(workflow.uuid)[rootGetters.userUUID])
    },
    canDeleteWorkflow: (state, getters) => workflow => getters.canEditWorkflow(workflow)
}

const mutations = {
    [WORKFLOW_PERMISSIONS_SET]: (state, permissions) => {
        state.permissions = permissions
    },
    [WORKFLOW_PERMISSIONS_UPDATE]: (state, {workflowUuid, workflowPermissions}) => {
        Vue.set(state.permissions, workflowUuid, workflowPermissions)
    }
}

const actions = {
    [WORKFLOW_PERMISSIONS_UPDATE]: async({getters, commit}, {workflowUuid, workflowPermissions}) => {
        if (!workflowUuid) {
            return
        }
        let members = []
        if (_.isPlainObject(workflowPermissions)) {
            members = Object
                .keys(workflowPermissions)
                .map(userUuid => ({
                    user_uuid: userUuid,
                    role: workflowPermissions[userUuid]
                }))
        }
        await axios.post(`automation/workflows/${workflowUuid}/members`, {members})
            .then(() => {
                commit(WORKFLOW_PERMISSIONS_UPDATE, {workflowUuid, workflowPermissions})
            })
            .catch(e => {
                Vue.prototype.$snackbar.show({type: ERROR})
                Raven.captureException(e)
            })
    },
    [WORKFLOW_PERMISSIONS_FETCH]: ({commit}) => {
        return axios.get(`automation/workflows/members`)
            .then((res) => {
                const members = res && res.data && _.isArray(res.data.data) ? res.data.data : []
                const permissions = members.reduce((map, obj) => {
                    if (!map[obj.workflow_uuid]) {
                        map[obj.workflow_uuid] = {}
                    }
                    map[obj.workflow_uuid][obj.user_uuid] = obj.role
                    return map
                }, {})
                commit(WORKFLOW_PERMISSIONS_SET, permissions)
            })
            .catch(e => {
                Vue.prototype.$snackbar.show({type: ERROR})
                Raven.captureException(e)
            })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
